import { render, staticRenderFns } from "./LeaveUser.vue?vue&type=template&id=50c8174e"
import script from "./LeaveUser.vue?vue&type=script&lang=js"
export * from "./LeaveUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports